<template>
    <li v-bind:class="['mygrid', {'blink':log_item.blink}, {'even':(order === 'even')}]" v-on:animationend="log_item.blink = false">
        <span class="two">
            <span class="text-overflow site-name"><a target="_blank" :href="log_item.site" v-bind:title="log_item.site">{{log_item.site}}</a></span>
            <a target="_blank" :href="log_item.site"><external-link-icon></external-link-icon></a>
            <copy-link v-bind:text-to-copy="log_item.site"></copy-link>
        </span>
        <span class="two"><span class="text-overflow" v-bind:title="log_item.request">{{log_item.request}}</span></span>
        <span class="two">
            <span class="text-overflow">
                <a target="_blank" :href="log_item.http_referer" v-bind:title="log_item.http_referer">{{log_item.http_referer}}</a>
            </span>
            <a target="_blank" :href="log_item.http_referer"><external-link-icon></external-link-icon></a>
            <copy-link v-bind:text-to-copy="log_item.http_referer"></copy-link>
        </span>
        <span class="cent" v-bind:title="log_item.date">{{log_item.date}}</span>
        <span class="two"><span class="text-overflow" v-bind:title="log_item.http_user_agent">{{log_item.http_user_agent}}</span><copy-link v-bind:text-to-copy="log_item.http_user_agent"></copy-link></span>
        <span class="cent">{{log_item.http_status}}</span>
    </li>
</template>

<script>
    import CopyLink from "@/components/UI/_base-UI-CopyLink";
    import { RefreshCwIcon, ExternalLinkIcon } from 'vue-feather-icons'

    export default {
        name: "AccessLogsRow",
        components:{
            CopyLink,
            RefreshCwIcon,
            ExternalLinkIcon
        },
        props:{
            log_item: Object,
            order: String
        }
    }
</script>

<style scoped>
    .one, .two{
        display: inline-flex;
        overflow: hidden;
        align-items: baseline;
    }

    .text-overflow{
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .text-overflow a{

    }

    #linkList ul li.mygrid {
        display: grid;
        grid-template-columns: 1fr 2fr 2fr 0.5fr 2fr 0.5fr;
        background: #dfdfdf;
        box-shadow: 0px 0px 0px #fff2a9;
        transition: all ease-in-out 0.3s;
    }

    #linkList ul li.even {
        background: #EEEEEE;
    }

    #linkList ul li.blink{
        animation: blink 1000ms ease 0s 1;
        animation-fill-mode: forwards;
    }

    #linkList ul li a svg{
    }

    @keyframes blink {
        0%{
            padding: 0.5rem;
            box-shadow: none;
            background-color: #dfdfdf;
            border-left: 1px solid #888;
            border-top: 1px solid #ffffff;
        }

        50%{
            top: -2px;
            box-shadow: inset 0px 0px 3px 1px #ffd89a;
            background-color: #fffdd1;
        }

        100%{
            padding: 0.5rem;
            box-shadow: none;
            background-color: #dfdfdf;
            border-left: 1px solid #888;
            border-top: 1px solid #ffffff;
            border-bottom: 1px solid #888;
        }
    }

    ul li a{
        color: #4e4872;
    }
</style>
